import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";

const CTA_IMG = "https://storage.helloreaddy.io/project_files/7dabfe77-b738-4536-b87c-583d4a2d32dc/2d06b821-0276-4a88-944d-7744fa009a6a_compressed_global-cta-evening-home-v2.webp";

export default function StartProjectCTA() {
  return (
    <section className="w-full relative overflow-hidden" style={{ minHeight: "560px" }}>
      <img src={CTA_IMG} alt="Warm residential interior at dusk"
           className="absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(29,26,23,0.62) 0%, rgba(29,26,23,0.44) 38%, rgba(29,26,23,0.3) 70%, rgba(29,26,23,0.3) 100%)" }} />
      <Reveal className="relative mx-auto max-w-content px-5 md:px-12 lg:px-16 py-24 md:py-32 flex flex-col md:flex-row md:items-end md:justify-between gap-10" offset={14} duration={750}>
        <div className="max-w-[720px]">
          <span className="eyebrow" style={{ color: "rgba(244,238,230,0.7)" }}>Start a Project</span>
          <h2 className="mt-5 font-serif-display font-light leading-[1.05]"
              style={{ color: "#F4EEE6", fontSize: "clamp(32px,3.4vw,46px)", letterSpacing: "-0.018em" }}>
            Have a home in mind?<br />
            <span className="italic">Let&rsquo;s talk about what it could become.</span>
          </h2>
        </div>
        <Link to="/contact" className="arrow-link text-[12px] tracking-[0.16em] uppercase cursor-pointer whitespace-nowrap"
              style={{ color: "#F4EEE6" }}>
          Start a Project
          <i className="ri-arrow-right-line arrow w-4 h-4 flex items-center justify-center" />
        </Link>
      </Reveal>
    </section>
  );
}